<script>
  import { Link } from 'svelte-navigator'
  import UserShort from './UserShort.svelte'

  export let user
</script>

<div class="usershort">
  <Link to="/users/{user.id}">
    <UserShort {user} />
  </Link>
</div>

<style>
  .usershort :global(a) {
    text-decoration: none;
    color: var(--bs-body-color);
  }

  .usershort :global(a:hover) {
    color: var(--bs-primary);
  }
</style>
